<template>
  <!-- Modal -->
  <div class="modal fade" id="CanNotOperateWithinDemoAlert" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <h5 class="modal-title" ></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding-bottom:2rem;">
          <trans-text i18nKey="ui[91][1]" :isHtml="true"/>
        </div>
        <!--<div class="modal-footer">-->
          <!--<button type="button" class="btn page-btn btn-secondary" data-dismiss="modal">Close</button>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
    }
  }
  //
  //DIコンテナ作成

  //alert("test");


</script>


<style lang="scss" scoped>
  .modal-header{
    background-color: #fef7ea;
  }

  .modal-body{
    font-size: .8rem;
  }
</style>



// WEBPACK FOOTER //
// CanNotOperateWithinDemoAlert.vue?fe224d24